
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, provideKeycloak } from 'keycloak-angular';

import { environment } from '../../../environments/environment';

const urlPatternEscaped = `^(${environment.API.orchestrator_training}|${environment.API.orchestrator_configurator}|${environment.API.orchestrator_chat})(/.*)?$`.replaceAll('/', '\\/');

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`${urlPatternEscaped}`, 'i'),
  bearerPrefix: 'Bearer'
});

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.KEYCLOAK.url,
      realm: environment.KEYCLOAK.realm,
      clientId: environment.KEYCLOAK.clientId
    },
    initOptions: {
      onLoad: 'login-required',
      enableLogging: environment.production ? false : true
    },
    providers: [{
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    }]
  });
